var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { SecuredData } from "../asset/securedDataWithMetaData";
import h from "../helper/helper";
var TopicUpdate = /** @class */ (function () {
    function TopicUpdate(_a) {
        var content = _a.content, server = _a.server, meta = _a.meta, sender = _a.sender;
        var _this = this;
        this.setState = function (newState) {
            _this.state = __assign({}, _this.state, newState);
        };
        this.getID = function () {
            return _this._id;
        };
        this.getTime = function () {
            return h.parseDecimal(_this.securedData.metaAttr("time"));
        };
        this.isAfter = function (topicUpdate) {
            if (!topicUpdate) {
                return true;
            }
            return topicUpdate.getTime() < _this.getTime();
        };
        this.ensureParent = function (topic) {
            _this.securedData.checkParent(topic.getSecuredData());
        };
        this.ensureIsAfterTopicUpdate = function (topicUpdate) {
            _this.securedData.checkAfter(topicUpdate.getSecuredData());
        };
        this.getUserID = function () {
            return _this.userID;
        };
        this.getSecuredData = function () {
            return _this.securedData;
        };
        this.getMetaUpdate = function () {
            return _this.securedData.metaAttr("metaUpdate");
        };
        var content = content, meta = meta;
        this._id = server.id;
        this.securedData = new SecuredData(content, meta, { type: "topicUpdate" }, true);
        this.userID = meta.userID;
        this.state = {
            loading: false,
            timestamp: h.parseDecimal(meta.time),
            title: content.title,
            sender: sender
        };
    }
    return TopicUpdate;
}());
export default TopicUpdate;



//////////////////
// WEBPACK FOOTER
// ./js/messages/chatTitleUpdate.ts
// module id = null
// module chunks = 